import { DashboardSelection, DashboardSelectionType, datestamp } from "@fusion-advantage/formlib"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface DashboardControlSliceState {
	displayDate: string
	selection: DashboardSelection
	videoBobJobberOpen: boolean
	joinedVideoEncounters: {[encounterGuid: string]: boolean}
	sentReminders: {[encounterGuid: string]: number}
}

const initialState: DashboardControlSliceState = {
	displayDate: datestamp(),
	selection: { type: DashboardSelectionType.TodaySummary },
	videoBobJobberOpen: false,
	joinedVideoEncounters: {},
	sentReminders: {},
}

const dashboardControlSlice = createSlice({
	name: 'dashboardControl',
	initialState,
	reducers: {
		setDashboardDisplayDate(state, action: PayloadAction<string>) {
			state.displayDate = action.payload
		},
		resetDashboardSelection(state) {
			state.selection = initialState.selection
		},
		setDashboardSelection(state, action: PayloadAction<DashboardSelection>) {
			state.selection = action.payload
		},
		setDashboardVideoBobJobberOpen(state, action: PayloadAction<boolean>) {
			state.videoBobJobberOpen = action.payload
		},
		pushDashboardJoinedVideoEncounter(state, action: PayloadAction<{encounterGuid: string}>) {
			state.joinedVideoEncounters[action.payload.encounterGuid] = true
		},
		incrementDashboardSentReminders(state, action: PayloadAction<{encounterGuid: string}>) {
			let count = state.sentReminders[action.payload.encounterGuid] ?? 0
			state.sentReminders[action.payload.encounterGuid] = count + 1
		},
	},
})

export const { setDashboardDisplayDate, resetDashboardSelection, setDashboardSelection, setDashboardVideoBobJobberOpen, pushDashboardJoinedVideoEncounter, incrementDashboardSentReminders } = dashboardControlSlice.actions
export default dashboardControlSlice.reducer
